import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './Header.css';

const KEY_IMG = '/images/Gold_key_with_fingerprint_design_no_bg.png';
const WORDMARK_IMG = '/images/syberkey_logo_no_bg.png';

function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="app-header-brand">
        <img src={KEY_IMG} alt="" className="app-header-brand-key" width={40} height={40} />
        <img src={WORDMARK_IMG} alt="SyberKey" className="app-header-brand-wordmark" />
      </div>

      <nav>
        <ul>
          {user ? (
            <>
              <li>
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li>
                <button type="button" onClick={handleLogout} className="logout-button">Logout</button>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to="/login">Login</Link>
              </li>
              <li>
                <Link to="/register">Register</Link>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
